import { Field, Form } from 'react-final-form'

import FormItem from 'common/components/FormItem'
import SingleSelect from 'common/components/singleSelect'
import useGetHeadersQuery from 'features/personalization/api/queries/useGetHeaders'
import useGetSelectedFiltersQuery from 'features/personalization/api/queries/useGetSelectedFilters'

const Filters = () => {
  const headersQuery = useGetHeadersQuery()
  const selectedFiltersQuery = useGetSelectedFiltersQuery()

  return (
    <Form<{ useCase: string | undefined; channel: string | undefined }>
      initialValues={{
        useCase: selectedFiltersQuery.data?.useCase,
        channel: selectedFiltersQuery.data?.channel,
      }}
      keepDirtyOnReinitialize
      onSubmit={(values) => {}}
      render={({ handleSubmit }) => (
        <form
          className="flex gap-6 px-6 pt-12 lg:pt-8  pb-6"
          onSubmit={handleSubmit}
        >
          <Field<string>
            name="useCase"
            render={({ input, meta }) => (
              <FormItem
                label="Usecase"
                htmlFor="useCase"
                className="max-w-75"
                error={meta.error}
              >
                <SingleSelect
                  id="useCase"
                  onChange={(val) => input.onChange(val?.value)}
                  value={input.value}
                  isSearchable={true}
                  required
                  isDisabled
                  options={
                    headersQuery.data?.useCase?.map(
                      ({ value, displayName }) => ({
                        label: displayName,
                        value,
                      })
                    ) ?? []
                  }
                />
              </FormItem>
            )}
          />
          <Field<string>
            name="channel"
            render={({ input, meta }) => (
              <FormItem
                label="Channels"
                htmlFor="channel"
                className="max-w-75"
                error={meta.error}
              >
                <SingleSelect
                  id="channel"
                  onChange={(val) => input.onChange(val?.value)}
                  value={input.value}
                  isSearchable={true}
                  isDisabled
                  required
                  options={
                    headersQuery.data?.channels?.map(
                      ({ value, displayName }) => ({
                        label: displayName,
                        value,
                      })
                    ) ?? []
                  }
                />
              </FormItem>
            )}
          />
        </form>
      )}
    />
  )
}
export default Filters
